import { object, string } from "yup"
import { useValidatorSeeker } from "@app"

import { userSettingCategoryFormData } from "../@signals"


const schema = object({
	color: string().required('Color is required'),
	id_category: string().required('Category is required'),
})

export default function useUserSettingsCategoryValidator() {
	const { isValid, errors } = useValidatorSeeker(userSettingCategoryFormData.value, schema)

	return {
		isValid,
		colorError: errors.color || null,
		categoryError: errors.id_category || null
	}
}